<template>
  <div class="product" ref="product">
    <van-row>
      <van-col span="24" v-if="isJdGoods">
        <div class="jd-notice">
          <p class="title">
            <img src="../../assets/shop/icon_left.png" />
            <span>买家须知</span>
            <img src="../../assets/shop/icon_right.png" />
          </p>
          <div class="item">
            <p class="item-title">关于赠品</p>
            <p class="little-title">About the gift</p>
            <p class="item-con">
              本商品无赠品，商品主图与详情仅供用户了解商品，赠品信息无效。
            </p>
          </div>
          <div class="item">
            <p class="item-title">关于售后</p>
            <p class="little-title">About after-sales</p>
            <p class="item-con">本商品不支持退换货服务。</p>
            <p class="item-con">
              本商品一经售出，即表明您已确认商品信息及买家须知。
            </p>
            <p class="item-con item-last">
              在商品有质量问题时，请先联系客服，沟通处理方案。
            </p>
          </div>
          <div class="item">
            <p class="item-title">关于发货</p>
            <p class="little-title">About the delivery</p>
            <p class="item-con">本商品运费以订单提交界面为准。</p>
            <p class="item-con">
              本商品不支持修改收件人信息，下单时请确保信息无误。
            </p>
            <p class="item-con">本商品不接急单，发货时间为：付款后5天内。</p>
            <p class="item-con item-last">
              本商品由京东发货，可能存在物流无法跟踪现象，具体以订单详情中信息为准。
            </p>
          </div>
          <div class="item">
            <p class="item-title">关于物流</p>
            <p class="little-title">About logistics</p>
            <van-row>
              <van-col span="12" class="logistics_item_l">
                <p class="item-con">1.微信查找进入小程序“小易来了”；</p>
              </van-col>
              <van-col span="12" class="logistics_item_r">
                <p class="item-con">2.输入收件人手机号码，验证并登录查看；</p>
              </van-col>
            </van-row>
            <van-row>
              <van-col span="12" class="logistics_step_l">
                <img src="../../assets/shop/logistics_first.png" />
              </van-col>
              <van-col span="12" class="logistics_step_r">
                <img src="../../assets/shop/logistics_second.png" />
              </van-col>
            </van-row>
          </div>
        </div>
      </van-col>

      <van-col span="24" v-if="isYunCang">
        <img
          src="../../assets/yuncang/tip-img.png"
          style="width: 100%"
          alt=""
        />
      </van-col>

      <van-col
        v-if="loaded"
        class="picture-text"
        span="24"
        v-html="productInfo"
      ></van-col>
      <van-col v-else class="picture-loading" span="24">
        <van-loading type="spinner">图片加载中...</van-loading>
      </van-col>
      <van-col class="explain" span="24">
        <div class="explain-inner">
          <p class="title">销巴生活平台价格说明</p>
          <p class="littleTit first"><span></span>划线价格（价格）:</p>
          <p>
            指商品的专柜价、吊牌价、厂商建议零售价、厂商指导价等，并非商品原价，仅供您参考。
          </p>
          <p class="littleTit"><span></span>未划线价格：</p>
          <p>
            商品的实际售价，是您最终决定是否购买商品（或服务）的依据。具体成交价格根据商品（或服务）参加活动，或您使用优惠券、积分等发生变化，最终以订单结算价格为准。
          </p>
          <p class="littleTit"><span></span>折扣：</p>
          <p>
            如无特殊说明，折扣指商家在划线价格等某一价格基础上计算出的优惠比例或优惠金额；如您对商品（或服务）促销信息或实际售价有疑问，您可在购买前联系商家进行咨询。
          </p>
        </div>
      </van-col>
    </van-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      id: 0,
      productInfo: "",
      isJdGoods: false,
      loaded: false,
      isYunCang: false,
    };
  },
  created() {
    this.$api.setToken();
    // localStorage.removeItem('_token');
  },
  methods: {
    getShopInfo() {
      this.id = this.$route.query.id;
      this.$api
        .get("/ongoods/index/goods/detail", { id: this.id })
        .then((res) => {
          if (res.goods.info && res.goods.info.content) {
            let _list = [];
            res.goods.info.content.replace(
              /<img[^<>]*src="([^"<>]*)"[^<>]*>/g,
              (s, m) => {
                console.log(m);
                _list.push(m);
              }
            );
            if (res.goods.goods_type == 4) {
              this.isYunCang = true;
            }
            console.log(_list);
            this.loadImage(_list).then(() => {
              console.log("all loaded");
              this.productInfo = res.goods.info.content;
              this.loaded = true;
              if (res.goods.goods_type == 3) {
                this.isJdGoods = true;
                var substr = res.goods.info.content.match(/cssurl='(\S*)'/);

                if (substr) {
                  var linkk =
                    "<link rel='stylesheet' type='text/css' href='" +
                    substr[1] +
                    "' media='all' />";
                  this.productInfo += linkk;
                }
                this.toTargetWidth();
              } else {
                this.params("", "", "onLoaded");
              }
            });
          } else {
            this.loaded = true;
          }
        })
        .catch((err) => {
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          this.$toast(message);
          return;
        });
    },
    loadImage(list) {
      return Promise.all(
        list.map((_) => {
          let img = new Image();
          img.src = _;
          return new Promise((resolve) => {
            img.onload = () => {
              console.log(_, "loaded");
              resolve(_);
            };
          });
        })
      );
    },
    toTargetWidth() {
      var timer = setInterval(() => {
        var targetDom = document.querySelector(".ssd-module-wrap");
        if (!targetDom) {
          clearInterval(timer);
          return this.params("", "", "onLoaded");
        }
        var boxHeight = document
          .querySelector("#zbViewModulesH")
          .getAttribute("value");
        console.log(boxHeight);
        if (targetDom && boxHeight) {
          clearInterval(timer);
          var clientWidth = document.body.clientWidth;
          var targetWidth = Math.min(750, clientWidth);
          var scaleValue = targetWidth / 750;
          var fontSizeValue = Math.round(14 / scaleValue);
          targetDom.style.transformOrigin = "0px 0px";
          targetDom.style.transform = "scale(" + scaleValue + ")";
          targetDom.style.fontSize = fontSizeValue + "px";
          targetDom.style.lineHeight = "2";
          document.querySelector(".picture-text").style.height =
            boxHeight * scaleValue + "px";
          this.params("", "", "onLoaded");
        }
      }, 100);
    },
  },
  mounted() {
    this.getShopInfo();
  },
};
</script>

<style lang="less">
body {
  min-height: 100%;
  height: auto;
  .product {
    background: #f2f2f2;
    .jd-notice {
      width: 100%;
      height: auto;
      margin-bottom: 12px;
      background: #fff;
      padding-bottom: 13px;
      .title {
        color: #fff;
        height: 26px;
        line-height: 26px;
        font-size: 15px;
        text-align: center;
        background: #ff6259;
        img {
          width: 24px;
          margin: 0 10px;
        }
      }
      .item {
        padding: 0 12px;
        text-align: left;
        line-height: 18px;
        .item-title {
          padding-top: 11px;
          color: #333;
          font-size: 13px;
          font-weight: bold;
        }
        .little-title {
          color: #333;
          font-size: 9px !important;
          font-weight: bold;
        }
        .item-con {
          color: #666;
          font-size: 12px;
        }
        .item-last {
          margin-bottom: 13px;
        }
        .logistics_item_l {
          padding-right: 11px;
        }
        .logistics_item_r {
          padding-left: 11px;
        }
        .logistics_step_l {
          padding-left: 8px;
          padding-right: 15px;
          img {
            width: 100%;
            display: block;
            margin-top: 8px;
          }
        }
        .logistics_step_r {
          padding-left: 15px;
          padding-right: 8px;
          img {
            width: 100%;
            display: block;
            margin-top: 8px;
          }
        }
      }
    }
    .tip {
      background-color: #ffffff;
      .content {
        margin: 15px 12px;
        padding: 10px;
        background-color: #fff5df;
        border-radius: 4px;
        box-shadow: 0px 3px 10px 0px rgba(153, 153, 153, 0.14);
        p {
          font-size: 13px;
          line-height: 21px;
        }
        .title {
          font-size: 15px;
          margin-bottom: 8px;
        }
      }
    }
    .picture-loading {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 15px;
      background-color: #ffffff;
    }
    .picture-text {
      background: #fff;
      width: 100% !important;
      border-bottom: solid 12px #f2f2f2;
      overflow: hidden;
      ol {
        list-style: decimal;
        padding-left: 40px;
      }
      ul {
        list-style: disc;
        padding-left: 40px;
      }
      img {
        width: 100% !important;
        display: block;
        height: auto !important;
        /*font-size: 14px !important;
				      color: #666 !important;*/
      }
    }
    .explain {
      background: #fff;
      padding: 12px 12px 15px;
      box-shadow: #e3e3e3 2px 0 4px;
      p {
        color: #999;
        font-size: 12px;
      }
      .title {
        color: #333;
        font-size: 13px;
        height: 20px;
        line-height: 20px;
        font-weight: 700;
      }
      .littleTit {
        color: #333;
        line-height: 24px;
        margin-top: 5px;
        span {
          width: 2px;
          height: 2px;
          display: inline-block;
          background: #333;
          border-radius: 1px;
          margin-right: 6px;
          margin-bottom: 2px;
        }
      }
      .first {
        margin-top: 0;
      }
    }
  }
}
</style>
